<template>
  <b-button
    size="sm"
    variant="secondary"
    class="d-flex align-items-center"
    data-test="download-pdf"
    @click="print()"
  >
    Download as PDF
  </b-button>
</template>
<script>

import { mapGetters, mapState } from 'vuex';
import * as contentTypes from '@/modules/content/store/types';

export default {
  name: 'PrintAdsBtn',
  data() {
    return {
      specs: 'fullscreen=yes,title=no,scrollbars=yes,margins=none;',
    };
  },
  computed: {
    ...mapState('campaigns', [
      'campaign',
    ]),
    ...mapState('content', [
      'sharedContentItems',
      'timestamp',
    ]),
    ...mapGetters('content', [
      contentTypes.GET_ACTIVE_CREATIVE_TEMPLATES,
      contentTypes.GET_ARTICLE_BY_UUID,
    ]),
    creativesGroupedForPages() {
      const activeTemplates = this.GET_ACTIVE_CREATIVE_TEMPLATES;
      const uniqueSizeIds = Array.from(new Set(activeTemplates.map((template) => template.sizeId)));
      if (uniqueSizeIds === activeTemplates.length) return [activeTemplates];

      const creativeInGroups = [];
      for (let i = 0; i < uniqueSizeIds.length; i++) {
        const creativesPerSize = activeTemplates.filter((template) => template.sizeId === uniqueSizeIds[i])
          .sort((a, b) => a.name.localeCompare(b.name));
        for (let j = 0; j < creativesPerSize.length; j++) {
          if (typeof creativeInGroups[j] === 'undefined') creativeInGroups[j] = [];
          creativeInGroups[j][i] = creativesPerSize[j];
        }
      }
      return creativeInGroups;
    },
    printWindowHtml() {
      return `
        <html>
          <head>
          <link href="/resources/print.css" type="text/css" rel="stylesheet">
            <title>${this.campaign.name} PDF</title>
          </head>
          <body>
            ${this.introPage}
            ${this.adsPages}
          </body>
        </html>
      `;
    },
    introPage() {
      return `
        <div class="page" id="spinner"></div>
        <div class="page intro">
          <div class="background">
            <div class="company-title"><img src="/images/smartmatch-logo-white.png" alt="Smartmatch" /></div>
            <div class="title">
              <h2>${this.campaign.name}</h2>
              <h3>Showcase</h3>
            </div>
            ${this.getFooter(true)}
          </div>
        </div>
      `;
    },
    adsPages() {
      let content = '';
      this.sharedContentItems
        .sort((a, b) => a.title.localeCompare(b.title))
        .forEach((contentItem) => {
          this.creativesGroupedForPages.forEach((creativesPerPage) => {
            content += `
            <div class="page" id="${contentItem.encodedExternalId}">
              <div class="header"><h3>${contentItem.title}</h3></div>
              <div class="content"><div class="adds">${this.iframes(contentItem.encodedExternalId, creativesPerPage)}</div></div>
              ${this.getFooter()}
            </div>
          `;
          });
        });
      return content;
    },
  },
  methods: {
    getFooter(isFirstPage) {
      const logo = isFirstPage ? 'smartmatch-logo-white.png' : 'smartmatch-logo.png';
      const bulbLogo = isFirstPage ? 'bulb-icon-white.png' : 'bulb-icon.png';
      return `
         <div class="footer">
            <img class="logo" src="/images/${logo}" alt="Smartmatch" />
            <img class="bulb" src="/images/${bulbLogo}" alt="Smartmatch" />
          </div>
      `;
    },
    getSourceDocument(creativeTemplate, articleUuid) {
      return `\x3cscript src="${process.env.VUE_APP_RENDER_API}/preview/creative/${creativeTemplate.creativeId}/key/${creativeTemplate.creativeKey}/acid/${articleUuid}?${this.timestamp}"\x3e\x3c/script\x3e`;
    },
    print() {
      const window = this.openWindow('', this.campaign.name, this.specs);
      window.document.write(this.printWindowHtml);
      this.updateIframes(window);
      const iframesAmount = this.sharedContentItems.length * this.GET_ACTIVE_CREATIVE_TEMPLATES.length;
      const timeLoading = 2000 + iframesAmount * 65;

      setTimeout(() => {
        const spinner = window.document.getElementById('spinner');
        spinner.style.display = 'none';
        window.focus();
        window.print();
      }, timeLoading);
    },
    iframes(contentUuid, creativesPerPage) {
      let content = '';
      creativesPerPage.forEach((template) => {
        content += `
          <div class="inline size-${template.width}x${template.height}"><iframe scrolling="no" id=${template.creativeId}-${contentUuid}></iframe></div>
        `;
      });
      return content;
    },
    updateIframes(window) {
      this.sharedContentItems.forEach((contentItem) => {
        this.GET_ACTIVE_CREATIVE_TEMPLATES.forEach((template) => {
          this.updateIframe(window, contentItem, template);
        });
      });
    },
    updateIframe(window, contentItem, template) {
      const iframe = window.document.getElementById(`${template.creativeId}-${contentItem.encodedExternalId}`);
      iframe.contentWindow.document.write(this.getSourceDocument(template, contentItem.encodedExternalId));
      iframe.setAttribute('width', template.width);
      iframe.setAttribute('height', template.height);
      iframe.setAttribute('scrolling', 'no');
      iframe.setAttribute('marginWidth', '0');
      iframe.setAttribute('marginHeight', '0');
      iframe.setAttribute('hspace', '0');
      iframe.setAttribute('vspace', '0');
      iframe.setAttribute('frameborder', '0');
    },
    openWindow(url, name, props) {
      const windowRef = window.open(url, name, props);
      windowRef.focus();
      return windowRef;
    },
  },
};
</script>
